export const PRODUCT_TRAY_DEFAULT_PEEK_MOBILE = 37;
export const PRODUCT_TRAY_DEFAULT_PEEK_MEDIUM = 34;
export const PRODUCT_TRAY_DEFAULT_PEEK_LARGE = 50;
export const LARGE_WITH_TILE_PEEK_MOBILE = 78;
